module.exports = __webpack_public_path__ + "img/抢单APP.1c7f126b.png";